export default __webpack_public_path__ + "static/media/training.1ffc3906.svg";